import React, { useState, useEffect, useCallback, useRef } from "react";
import EventsGalleryService from "../../../services/EventsGalleryService";
import Loadspinner from "../../../common/Loadspinner";
import Main from "../../../common/Main/Main";
import "./EventGalleryEdit.css";
import DynamicGrid from "../../../ReusableComponents/DynamicGrid/DynamicGrid";
import { debounceSearchRender } from "mui-datatables";
import InputForm from "../../../ReusableComponents/InputForm/InputForm";
import { APICall } from "../../../helpers/API/APICalls";
import * as urls from "../../../helpers/API/APIEndPoints";
import ButtonForm from "../../../ReusableComponents/ButtonForm/ButtonForm";
import { Button, Card, Form, Image, InputGroup } from "react-bootstrap";
import Heading from "../../../ReusableComponents/Heading/Heading";
import { del, ic_broken_image } from "../../../constants/Images";
import { Redirect, useHistory, useParams } from "react-router";
import { Modal } from "@material-ui/core";
import CreateKnowledgeService from "../../../services/CreateKnowledgeService";
import notify from "../../../ReusableComponents/ToastNotification/ToastNotification";
import DeleteDialogueBox
  from "../../../ReusableComponents/DeleteDialogueBox/DeleteDialogueBox";
import {
  fileDeletionMsg,
  saveRecordMsg,
  updateRecordMsg,
} from "../../../helpers/Constants/Constants";
import { downloadBlob } from "../../../services/CommonService";
import FormLabel from "../../../ReusableComponents/FormLabel/FormLabel";
import CancelButton from "../../../ReusableComponents/Buttons/CancelButton/CancelButton";
import ResetButton from "../../../ReusableComponents/Buttons/ResetButton/ResetButton";
import SubmitButton from "../../../ReusableComponents/Buttons/SubmitButton/SubmitButton";
import Decrypt2 from "../../../helpers/Cryptography/CryptoJS";
import ErrorLabel from "../../../ReusableComponents/ErrorLabel/ErrorLabel";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import CommonConstants from "../../../constants/CommonConstants";
import { getFromEncLocalStorage } from "../../../helpers/Utils/Utils";


const EventGalleryEdit = () => {
  // const { id: galleryId } = useParams();
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState('');
  const [sequence, setSequence] = useState('');
  const [oldSequence, setOldSequence] = useState(-1);
  const [isActive, setIsActive] = useState(true);
  const [files, setFiles] = useState([]);
  const [showDeleteConfirmationModal, setShowDeleteConfirmationModal] = useState(false);
  const [fileToBeDeleted, setFileToBeDeleted] = useState(null);
  const [Id, setId] = useState(0);
  const [formErrors, setFormErrors] = useState({});
  const history = useHistory();

  const inputFileRef = useRef();

  const [allowedFileTypes, setAllowedFileTypes] = useState('');
  useEffect(() => {
    const allowedImagesFileTypesLS = getFromEncLocalStorage("ImageFilesValidationExtension");
    const allowedVideoFileTypesLS = getFromEncLocalStorage("VideoFilesValidationExtension");
    if (allowedImagesFileTypesLS || allowedVideoFileTypesLS) {
      setAllowedFileTypes(
        [...allowedImagesFileTypesLS.split(','), ...allowedVideoFileTypesLS.split(',')].map(aift => `.${aift}`).join(',')
      );
    }
  }, [])


  const onFileChange = (e) => {
    if ([...e?.target?.files].filter(f => !(f.type.startsWith("image") || f.type.startsWith("video"))).length > 0) {
      notify(1, "Only images & videos are allowed!");
      return;
    }
    // #region check file extension with config value
    const allowedFileTypesArr = allowedFileTypes?.split(',');
    if (allowedFileTypesArr) {
      let isExtensionAllowed = true;
      let filesToCheck = [...e?.target?.files];
      for (let index = 0; index < filesToCheck.length; index++) {
        const fileToCheck = filesToCheck[index];
        isExtensionAllowed = allowedFileTypesArr.some(ext => fileToCheck?.name?.endsWith(ext));
        if (!isExtensionAllowed) break;
      }
      if (!isExtensionAllowed) {
        notify(1, `Only ${allowedFileTypesArr?.join(', ')} files are allowed!`);
        return;
      }
    }
    // #endregion
    //getFileMime(e?.target?.files?.[0]).then(res => console.log('getFileMime : ' + res));
    let filesTmp = [...files];
    setFiles(filesTmp);
    for (let index = 0; index < e?.target?.files?.length; index++) {
      const file = e?.target?.files?.[index];
      if (file) {
        filesTmp.push({ localUrl: URL.createObjectURL(file), blob: file, id: `img_${index}`, name: file.name, size: file.size, type: file.type });
      }
    }
    setFiles(filesTmp);

    let errorProperties = { ...formErrors };
    errorProperties.attachments = filesTmp.length == 0 ? "attachments cannot be empty." : "";
    setFormErrors(errorProperties)
  }

  const handleBtnClick = e => {
    inputFileRef.current.click();
  }


  const deleteImage = async file => {
    setLoading(true);
    try {
      let filesTmp = [...files];
      filesTmp = filesTmp.filter(f => f.id !== file.id)
      setShowDeleteConfirmationModal(false);

      if (file?.globalUrl) {
        const res = await APICall(urls.deleteDocument, {
          ids: `${file.id}`,
          name: file.azureFileName
        });

        if (res.message === "Ok") {
          if (res && res.data !== 0) {
            notify(0, fileDeletionMsg);
          }
        } else {
          notify(1, res.message);
        }
      }

      URL.revokeObjectURL(file.localUrl);

      setFiles(filesTmp);
    } catch (err) { } finally {
      setLoading(false);
    }
  }

  const createEventGallery = async () => {
    setLoading(true);
    try {
      let filesTmp = [...files];
      for (let index = 0; index < filesTmp?.length; index++) {
        const file = filesTmp?.[index];
        if (!file?.globalUrl) {
          let resp = await saveImage(file.blob);
          let imgUrl = resp?.result?.[0];
          if (imgUrl) {
            file.globalUrl = imgUrl;
          }
        }
      }
      setFiles(filesTmp);

      if (filesTmp.filter(f => !f?.globalUrl).length > 0) {
        //some images failed to upload.
        notify(1, "Some of the images have been failed to upload. Please try again.");
        return;
      }
      let creator = getFromEncLocalStorage("userId");

      const res = await APICall(urls.createEventGallery, {
        Id: Id,
        mode: Id ? "edit" : "create",
        title: title,
        sequence: sequence,
        oldSequence: oldSequence,
        isActive: isActive,
        attachments: filesTmp,
        createdBy: creator,
        modifiedBy: Id ? creator : null
      });

      if (res.message === "Ok") {
        if (res && res.data !== 0) {
          //if (Id === 0) {
          notify(0, saveRecordMsg);
          // } else if (Id > 0) {
          //   notify(0, updateRecordMsg);
          // }
          history.push({ pathname: "/event-gallery-master" });
        }
        setLoading(false);
      } else {
        notify(1, typeof res?.message === 'string' ? res?.message : res?.message?.message);
        setLoading(false);
      }
    } catch (err) {
      notify(1, "Failed to upload images. Please try again later.");
    } finally {
      setLoading(false);
    }

  }

  const saveImage = async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    let resp = await CreateKnowledgeService.fileUpload(formData, "gallery");

    return resp;
  }

  useEffect(() => {
    (async () => {
      // let state_id = galleryId;//history?.location?.state?.id;
      let state_id = await Decrypt2(getFromEncLocalStorage("tokennumber")); //history?.location?.state?.id;
      if (state_id) {
        getEventGalleryMasterDataByIdApiCall(state_id);
      }
    })();
  }, []);

  const getEventGalleryMasterDataByIdApiCall = async (id) => {
    setLoading(true);
    const data = await APICall(urls.getEventGalleryMasterDataById, { id: id });

    if (data.message === "Ok") {
      if (data && data.data && data.data[0][0] && data.data[0][0].id) {
        let dataArr = data.data[0];
        let dataObj = dataArr[0];
        setId(dataObj.id);
        setTitle(dataObj.Name);
        setSequence(dataObj.Sequence);
        setOldSequence(dataObj.Sequence);
        setIsActive(dataObj.IsActive);

        let filesTmp = [];
        setFiles(filesTmp);
        for (let index = 0; index < dataArr?.length; index++) {
          dataObj = dataArr?.[index];
          if (dataObj) {
            const fullResImgUrl = await downloadBlob(dataObj.docUrl);
            const azureFileName = new URL(dataObj?.docUrl)?.pathname?.split('/')?.pop();
            filesTmp.push({
              localUrl: null,
              blob: null,
              id: dataObj.docid || `img_${index}`,
              name: dataObj.DocName,
              size: null,
              type: dataObj.docExtension,
              globalUrl: fullResImgUrl,
              azureFileName: azureFileName,
              exists: true
            });
          }
        }
        setFiles(filesTmp);
        //setEditModeIsActive(false);
        //setEditModeDisableButton(false);
      }
      setLoading(false);
    } else {
      notify(1, data.message);
      setLoading(false);
    }
  };

  const handleEvents = async (event, field, label, required = false) => {
    const fieldValue = event.target.value;
    let errorProperties = { ...formErrors };
    switch (field) {
      case "title":
        setTitle(fieldValue);
        errorProperties.title = !fieldValue ? "Title cannot be empty." : "";
        break;
      case "sequence":
        setSequence(fieldValue);
        errorProperties.sequence = !fieldValue ? "Sequence cannot be empty." : "";
        break;
      case "isactive":
        setIsActive(event.target.checked);
        errorProperties.isactive = !Id && event.target.checked === false ? "Active must be selected." : "";
        break;
      case "attachments":
        handleBtnClick(event);
        break;
    }

    setFormErrors(errorProperties);
  };


  const onClickFunction = async (event, action) => {
    if (action === "Submit") {
      let isEmpty = checkValidations();
      if (!isEmpty) {
        await createEventGallery();
      }
    } else if (action === "Reset") {
      resetFunction();
    } else if (action === "Cancel") {
      history.push({ pathname: "/event-gallery-master" });
    }
  };


  const resetFunction = () => {
    setFormErrors({});
    setTitle("");
    setSequence("");
    setIsActive(false);
    setFiles([]);
  };


  const checkValidations = () => {
    let errorProperties = { ...formErrors };
    errorProperties.title = !title ? "Title cannot be empty." : "";
    errorProperties.sequence = (!sequence || !(/^[0-9]+$/.test(sequence))) ? "Sequence should be numeric." : "";
    errorProperties.isactive = !Id && !isActive ? "Active must be selected." : "";
    errorProperties.attachments = files.length == 0 ? "attachments cannot be empty." : "";
    setFormErrors(errorProperties);

    let isError =
      errorProperties.title ||
      errorProperties.sequence ||
      errorProperties.isactive ||
      errorProperties.attachments;

    return isError;
  };

  return (
    <>
      <Main active={"event_gallery_master"} removeContainer={true}>
        <Loadspinner filename="EventGalleryEdit.js" isLoading={loading} isMiddle="false" />
        <div className="eventGallery">
          <div className="col-lg-12">
            <div className="row">
              <div className="col-md-4">
                <h4 style={{ paddingLeft: "15px" }}>Master</h4>
              </div>
            </div>
          </div>
        </div>
        <div className="clearfix"></div>
        <div
          className="d-flex align-items-center justify-space-between"
          style={{
            background: "#e61636",
            padding: "10px 20px 10px 10px",
            color: "white",
            width: "100%",
          }}
        >
          <div className="col-lg-8 headerText">Event Gallery</div>
        </div>

        <div className="mx-3">
          <div className="col-lg-12 col-md-12 mt-3">
            <div className="row">
              <div className="col-lg-4 col-sm-4 col-xs-4 ">
                <div className="form-group">
                  {/* <label className="col-form-label">Event title</label> */}
                  <FormLabel value="Event Title" />
                  <sup>*</sup>
                  <InputForm
                    id="eventTitle"
                    className="form-control form-control-sm"
                    placeholder={"Enter event title"}
                    textArea={false}
                    value={title}
                    onChange={(e) => handleEvents(e, "title", "Event title", true)}
                  />
                  {/* <p style={{ color: "red" }}>
                    {formErrors["title"]}
                  </p> */}
                  <ErrorLabel value={formErrors["title"]} />
                </div>
              </div>
              <div className="col-lg-4 col-sm-4 col-xs-4 ">
                <div className="form-group">
                  {/* <label className="col-form-label">Sequence</label> */}
                  <FormLabel value="Sequence" />
                  <sup>*</sup>
                  <InputForm
                    className="form-control form-control-sm"
                    placeholder={"sequence"}
                    textArea={false}
                    value={sequence}
                    type="number"
                    onChange={(e) => handleEvents(e, "sequence", "Sequence", true)}
                  />
                  {/* <p style={{ color: "red" }}>
                    {formErrors["sequence"]}
                  </p> */}
                  <ErrorLabel value={formErrors["sequence"]} />
                </div>
              </div>
              <div className="col-lg-4 col-sm-4 col-xs-4">
                <div className="form-group">
                  {/* <label className="col-form-label">Active Status</label> */}
                  <FormLabel value="Active Status" />
                  <sup>*</sup>
                  <div className="custom-checkbox">
                    <input
                      type="checkbox"
                      onChange={(e) => handleEvents(e, "isactive", "Active", true)}
                      name="isActive"
                      checked={isActive}
                      className="isActive"
                      disabled={Id ? false : true}
                      autoComplete={CommonConstants.autoCompleteInput}
                    />
                    {/* <p style={{ color: "red" }}>
                      {formErrors["isactive"]}
                    </p> */}
                    <ErrorLabel value={formErrors["isactive"]} />
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-sm-4 col-xs-4 ">
                <div className="form-group">
                  {/* <label className="col-form-label">Attach images/videos</label> */}
                  <FormLabel value="Attach images/videos" />
                  <sup>*</sup>
                  <InputGroup className="mb-3">
                    <InputForm
                      className="form-control form-control-sm fileInputStyle"
                      placeholder={files.length + " images/videos selected"}
                      isDisabled={false}
                      textArea={false}
                      onClick={(e) => handleEvents(e, "attachments", "Attachments", true)}
                      readOnly
                    />
                    <ButtonForm variant="secondary" id="button-addon2" value="Browse" onClick={e => handleEvents(e, "attachments")} />
                  </InputGroup>
                  <input
                    type="file"
                    style={{ display: 'none' }}
                    id="btn_event_gallery_master_file_input"
                    ref={inputFileRef}
                    onChange={onFileChange}
                    onClick={(event) => {
                      event.target.value = null
                    }}
                    multiple
                    accept={allowedFileTypes}
                    autoComplete={CommonConstants.autoCompleteInput}
                  />
                  {/* <p style={{ color: "red" }}>
                    {formErrors["attachments"]}
                  </p> */}
                  <ErrorLabel value={formErrors["attachments"]} />
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            {files?.map((file, fIdx) => {
              return (
                <Card key={`img${fIdx}`} className="col-lg-2 col-sm-2 col-xs-2 imgCard" >
                  {/* <div className="fileImageParent"> */}
                  {
                    file.type.startsWith('video') ?
                      <video src={file?.localUrl || file?.globalUrl} className="gridImage" /> :
                      <Card.Img variant="top" src={file?.localUrl || file?.globalUrl} className="gridImage"
                        onError={({ currentTarget }) => {
                          currentTarget.onerror = null; // prevents looping
                          currentTarget.src = ic_broken_image;
                        }} />
                  }
                  {/* <div className="fileImageProgressIcon">
                      <CloudUploadIcon sx={{
                        width: "100%",
                        height: "8rem",
                        color: "white",
                      }} className="uploadIconAnimClass" />
                    </div>
                  </div> */}
                  <Card.Body className="imgCardBody">
                    <div className="row my-1">
                      <div className="col-lg-10 col-sm-10 col-xs-10 text-center">
                        <Card.Text>{file?.name}</Card.Text>
                      </div>
                      <div className="col-lg-2 col-sm-2 col-xs-2">
                        <Button variant="outline-light" size="sm">
                          <Image src={del} className="delBtn" onClick={() => {
                            setFileToBeDeleted(file);
                            setShowDeleteConfirmationModal(true);
                          }} />
                        </Button>
                      </div>
                    </div>
                  </Card.Body>
                </Card>
              )
            })
            }
          </div>

          <div className="col-lg-12 col-md-12 mt-3  d-flex justify-content-end my-3">
            <SubmitButton onClick={(e) => onClickFunction(e, "Submit")} />
            {!Id && (
              <ResetButton onClick={(e) => onClickFunction(e, "Reset")} />
            )}
            <CancelButton onClick={(e) => onClickFunction(e, "Cancel")} />
          </div>
        </div>

        {/* <Modal
          open={showDeleteConfirmationModal}
          onClose={() => setShowDeleteConfirmationModal(false)}
          className="modal-dialog modal-dialog-centered"
        >
          <div className="modal-content logout-modal">
            <div className="modal-body">
              Are you sure you want to delete this image?
            </div>
            <div className="display-row justify-space-evenly">
              <button
                className="btn btn-secondary"
                type="button"
                onClick={() => {
                  setFileToBeDeleted(null);
                  setShowDeleteConfirmationModal(false);
                }}
              >
                Cancel
              </button>
              
              <button
                className="btn btn-danger"
                type="button"
                onClick={() => deleteImage(fileToBeDeleted)}
              >
                Delete
              </button>
             
            </div>
          </div>
        </Modal> */}
        <DeleteDialogueBox
          open={showDeleteConfirmationModal}
          close={() => setShowDeleteConfirmationModal(false)}
          cancel={() => {
            setFileToBeDeleted(null);
            setShowDeleteConfirmationModal(false);
          }}
          deleteImage={() => deleteImage(fileToBeDeleted)}

        />
      </Main >
    </>
  );
}

export default EventGalleryEdit;
